// eslint-disable-next-line no-unused-vars
import { Spacing } from '../types';

const spacing4 = '4px';
const spacing8 = '8px';
const spacing12 = '12px';
const spacing16 = '16px';
const spacing20 = '20px';
const spacing24 = '24px';
const spacing28 = '28px';
const spacing32 = '32px';
const spacing36 = '36px';
const spacing40 = '40px';
const spacing44 = '44px';
const spacing48 = '48px';
const spacing52 = '52px';
const spacing56 = '56px';
const spacing60 = '60px';
const spacing72 = '72px';

export const generalSpacing = {
  spacing4,
  spacing8,
  spacing12,
  spacing16,
  spacing20,
  spacing24,
  spacing28,
  spacing32,
  spacing36,
  spacing40,
  spacing44,
  spacing48,
  spacing52,
  spacing56,
  spacing60,
  spacing72,
};

export const specificSpacing = {
  focusBorder: '3px',

  input: {
    height: spacing44,
  },

  button: {
    height: spacing44,
  },

  checkbox: {
    height: spacing12,
  },

  radioButton: {
    height: spacing12,
  },
};

export const spacing: Spacing = {
  ...generalSpacing,
  ...specificSpacing,
};
